import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function ConfirmDialog(props) {
  const {
      open,
      title,
      text,
      form,
      agreeText,
      declineText,
      handleClose,
      agreeColor,
  } = props;

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose(null)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {text}
          </DialogContentText>
          {form !== undefined && form}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose('agree')} color={agreeColor || "primary"}>
            {agreeText}
          </Button>
          <Button onClick={handleClose('decline')} autoFocus>
            {declineText}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}